export enum EstimatePrintTypeEnum {
  Summary = 0,
  Detail = 1,
}
